import React from 'react'
import Main from './components/Main'

function App() {
    return (
        <div>
            <h1>Text Message Sentiment Analysis</h1>

            <Main />
        </div>
    )
}

export default App;